export default __webpack_public_path__ + "static/media/heart-chakra.567685df.png";